/**
 * ResultsGrid — product cards grid in content area
 */

import { createElement, clearChildren } from '../utils/dom.js';
import ProductCard from './ProductCard.js';

export default class ResultsGrid {
  /**
   * @param {Object} eventBus
   * @param {Object} i18n
   */
  constructor(eventBus, i18n) {
    this._eventBus = eventBus;
    this._i18n = i18n;

    this._el = null;
    this._counterEl = null;
    this._gridEl = null;
  }

  /**
   * Render the results container
   * @param {HTMLElement} container
   */
  render(container) {
    this._el = createElement('div', 'grb-widget--results');

    // Header with counter
    const header = createElement('div', 'grb-widget--results-header');
    this._counterEl = createElement('div', 'grb-widget--results-count');
    header.appendChild(this._counterEl);

    this._gridEl = createElement('div', 'grb-widget--results-grid');

    this._el.appendChild(header);
    this._el.appendChild(this._gridEl);

    container.appendChild(this._el);
  }

  /**
   * Update results display
   * @param {Array} products
   * @param {number} totalCount
   * @param {string} currency
   * @param {Object} [widgetParams]
   */
  update(products, totalCount, currency, widgetParams) {
    if (!this._el) return;

    this._counterEl.textContent = this._i18n.t('results.found', { count: totalCount });

    clearChildren(this._gridEl);

    for (const product of products) {
      const card = new ProductCard(product, currency, this._eventBus, widgetParams);
      this._gridEl.appendChild(card.render());
    }
  }

  hide() {
    if (this._el) this._el.style.display = 'none';
  }

  show() {
    if (this._el) this._el.style.display = '';
  }

  destroy() {
    if (this._el && this._el.parentNode) {
      this._el.parentNode.removeChild(this._el);
    }
    this._el = null;
  }
}
